/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { InputNumber, Button, message } from 'antd';
import { graphql } from 'react-apollo';

import NewCacFinancialsForm from '../../forms/NewCacFinancialsForm';

import MUTATION from '../../graphql/mutations/editCustomerAssociateConcernMutation.graphql';

const KFP = [
  {
    name: 'Sales Turnover',
    key: 'sales_turnover',
  },
  {
    name: 'PAT',
    key: 'pat',
  },
  {
    name: 'Equity',
    key: 'equity',
  },
  {
    name: 'TNW',
    key: 'tnw',
  },
  {
    name: 'NWC',
    key: 'nwc',
  },
  {
    name: 'Debt',
    key: 'debt',
  },
  {
    name: 'TOL / TNW',
    key: 'tol_tnw',
  },
  {
    name: 'DER',
    key: 'der',
  },
];

class AssociateConcernFinancials extends Component {
  constructor(props) {
    super(props);
    if (props.financials) {
      this.state = {
        submittingForm: false,
        ...props.financials,
      };
    } else {
      this.state = {
        submittingForm: false,
        id: (+new Date()).toString(36),
        current_year: null,
        audited_years_count: null,
      };
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.financials, nextProps.financials)) {
      this.setState({
        ...this.state,
        ...nextProps.financials,
      });
    }
  }

  handleFormSave = (values) => {
    const { current_year, audited_years_count } = values;

    const years = [];
    const valArr = [];
    for (let i = (audited_years_count - 1); i >= 0; i--) {
      years.push(current_year - i);
      valArr.push(0);
    }

    this.setState({
      ...values,
      years,
      sales_turnover: [...valArr],
      pat: [...valArr],
      equity: [...valArr],
      tnw: [...valArr],
      nwc: [...valArr],
      debt: [...valArr],
      tol_tnw: [...valArr],
      der: [...valArr],
    });
  };

  handleSubmit = () => {
    this.setState({
      submittingForm: true,
    });
    const { submittingForm, __typename, ...values } = this.state;
    const { cac_id, mutate } = this.props;

    mutate({
      variables: {
        id: cac_id,
        brief_financials: { ...values },
      },
    })
      .then(() => {
        this.setState({
          submittingForm: false,
        });
        message.success('Success!');
      })
      .catch((mutateErr) => {
        console.log(mutateErr);
        this.setState({
          submittingForm: false,
        });
        message.error(mutateErr.message);
      });
  };

  render() {
    const { current_year, audited_years_count, years } = this.state;
    if (current_year && audited_years_count) {
      return (
        <div>
          <h4>Brief Financials</h4>
          <table className="table">
            <thead>
              <tr>
                <th>Particulars</th>
                {
                  years.map((year) => (<th key={year}>{year}</th>))
                }
              </tr>
            </thead>
            <tbody>
              {
                KFP.map((entry) => {
                  const arr = [...this.state[entry.key]];
                  return (
                    <tr key={entry.key}>
                      <td>{entry.name}</td>
                      {
                        arr.map((value, index) => (
                          <td key={`${entry.key}-${index}`}>
                            <InputNumber
                              className="excel-input-wrapper"
                              precision={2}
                              value={value}
                              onChange={(val) => {
                                arr[index] = val;
                                this.setState({
                                  [entry.key]: arr,
                                });
                              }}
                            />
                          </td>
                        ))
                      }
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
          <br />
          <Button onClick={this.handleSubmit} loading={this.state.submittingForm} type="primary">Save</Button>
        </div>
      );
    }
    return (
      <div>
        <h4>Brief Financials</h4>
        <NewCacFinancialsForm fields={{ current_year, audited_years_count }} submitFormData={this.handleFormSave} />
      </div>
    );
  }
}

AssociateConcernFinancials.propTypes = {
  financials: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  cac_id: PropTypes.string.isRequired,
  // customer_id: PropTypes.string.isRequired,
  mutate: PropTypes.func.isRequired,
};

AssociateConcernFinancials.defaultProps = {
  financials: null,
};

export default graphql(MUTATION)(AssociateConcernFinancials);



// WEBPACK FOOTER //
// ./src/pages/factsheet/AssociateConcernFinancials.jsx